'use client';

import dynamic from 'next/dynamic';
import Loader from '~/components/loading';

/**
 * Аккордионы на сервере и на клиенте получают разные ID
 * Из-за чего случается ошибка гидрации у некста
 * Потому рендер полностью выносится на клиент
 */

const FAQList = dynamic(() => import('./list'), {
  ssr: false,
  loading: () => <Loader />,
});

export default FAQList;
